import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-webiat-text-input',
  templateUrl: './webiat-text-input.component.html',
  styleUrls: ['./webiat-text-input.component.scss'],
})
export class WebiatTextInputComponent implements OnInit {
  @Input() placeholder!: string;
  @Input() label!: string;
  @Input() maxlength!: number;
  @Input() isLengthLimited: boolean = true;
  @Input() control: FormControl = new FormControl();
  @Input() showIcon: boolean = false;
  @Input() iconPath: string = '';
  @Input() inputType: string = 'text';
  @Input() isDisabled: boolean = false;
  @Input() isRequired: boolean = false; // Nouvel attribut pour indiquer si le champ est requis
  @Input() maxAcceptedAmount: number | null = null;
  @Input() maxAcceptedDuration: number | null = null;
  @Output() inputChanged = new EventEmitter<string>();

  public value: string = '';
  public isFocused: boolean = false;
  public characterLimit: number = 60;
  public showCharacterCount: boolean = false;
  public isTouched: boolean = false;


  ngOnInit(): void {
    if (this.maxlength) {
      this.characterLimit = this.maxlength;
    }
  }

  public hasError(errorType: string): boolean {
    return this.control.hasError(errorType) && this.control.touched;
  }

  public onInputFocus(): void {
    this.isFocused = true;
    this.isTouched = true;
    this.showCharacterCount = true;
  }

  public onFocusOut(): void {
        
    if (this.inputType === 'tel'){
      this.isFocused = false;
      this.control.value?.length < 8? this.showCharacterCount = false : this.showCharacterCount = true;
    }
  }

  onInputChanged(event: any) {
    let inputValue = event.target.value;
    // to remove anything except of alphanumeric and special characters
    inputValue = inputValue.replace(/[^a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>+\-/;µ§¨£ù°=`ØŒœ»©™▀²ôÔéàêâîï¤çèÉÀÿŸûÛüÜæÆëËÊÂÎÏÇÈÙ'~\[\]\\_]|(\d\uFE0F\u20E3)|([#*]\uFE0F\u20E3)/g, '');
    // to remove leading spaces
    inputValue = inputValue.replace(/^\s+/, '');
    // to replace consecutive spaces with a single space
    inputValue = inputValue.replace(/\s{2,}/g, ' ');
    this.value = inputValue;
    this.inputChanged.emit(this.value);
    
    if (this.isLengthLimited && this.inputType === 'number'){
      if (this.isLengthLimited && inputValue.length > this.maxlength) {        
        inputValue = inputValue.substring(0, this.maxlength);        
        this.value = inputValue;
        this.inputChanged.emit(this.value);
      }

    }
  }

}
